import { Box, Grid2, Link, List, ListItemButton, ListSubheader, Paper, SpeedDial, SpeedDialAction, SpeedDialIcon, Typography, useTheme } from "@mui/material";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import _ from "lodash";
import moment from "moment";
import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCalendar } from "../calendar/calendar.util";
import MonthlyDay from "../calendar/monthly/monthly.day";
import { DialogsContext, SessionDataContext } from "../contexts";
import EnrollmentCard2 from "../enrollment/enrollment.card2";
import StudentCard from "./student.card";
import StudentName from "./student.name";
import { studentApi } from "./student.queries";

export default function StudentView(props) {
	const navigate = useNavigate();
	const { id } = useParams();
	const useGet = studentApi.useGet(id);
	const student = useGet?.data;
	
	const useGetAll = studentApi.useGetAll();
	let students = useGetAll?.data;

	const theme = useTheme();
	const { dialogs } = useContext(DialogsContext);
	const sessionData = useContext(SessionDataContext);

	const noop = (referenceDate, start) => {
		return moment(referenceDate);
	}
	const unit = 'day';
	const calendar = useCalendar(unit, noop, noop, [(activity => activity.enrollment?.student?.id == student?.id)]);
	const date = calendar.startDate;

	if (!student) {
		return;
	}

	student.enrollments = student.enrollments?.filter(enrollment => enrollment.course?.id != null);
	const unplannedEnrollments = student.enrollments?.filter(enrollment => enrollment.completeness < 100 && enrollment.startDate == null);
	const upcomingEnrollments = student.enrollments?.filter(enrollment => enrollment.completeness < 100 && enrollment.startDate > new Date().getTime());
	const activeEnrollments = student.enrollments?.filter(enrollment => enrollment.completeness < 100 && (enrollment.startDate < new Date().getTime() && enrollment.endDate > new Date().getTime()));
	const completedEnrollments = student.enrollments?.filter(enrollment => enrollment.completeness >= 100);

	const wrapper = {
		width: '100%',
		height: '100%',
		overflow: 'hidden',
		position: 'absolute',
		display: 'flex',
		flexDirection: 'column',
	}

	const ribbon = {
		textAlign: 'center',
		transform: 'rotate(-30deg)',
		position: 'relative',
		top: '10%',
		left: '-50%',
		padding: 0.5,
		marginLeft: 10,
		backgroundColor: 'rgba(76, 175, 80, 0.95)',
		color: theme.palette.common.white,
		zIndex: 1,
	}
	const bestRibbon = (
		<Box sx={wrapper}>
			<Typography sx={ribbon} variant="subtitle2">
				Best
			</Typography>
		</Box>
	);

	const renderEnrollmentGroup = (label, enrollments) => {
		enrollments = _.sortBy(enrollments, ['course.subject.name', 'course.name']);
		const maxScore = _.chain(enrollments).map('score').max().value();
		return (
			<Box>
				<Divider sx={{ pt: 3, pb: 2 }} textAlign="left">
					<Typography variant="h6">{label} ({enrollments.length})</Typography>
				</Divider>

				<Grid2 container>
					{enrollments?.length > 0 &&
						enrollments?.map(enrollment =>
							<Grid2 size={{ xs: 12, md: 6, lg: 4, xl: 3 }} key={enrollment.id} sx={{ position: 'relative' }}>
								{enrollment.score > 0 && enrollment.score == maxScore && bestRibbon}
								<EnrollmentCard2 enrollment={enrollment} sx={{}} />
							</Grid2>
						)
					}
					{enrollments?.length == 0 &&
						<Typography sx={{ p: 8, fontSize: '1.25rem', fontStyle: 'italic', textAlign: 'center', flex: 1, color: 'muted' }}>-- No {label} --</Typography>
					}
				</Grid2>
			</Box>
		);
	};

	return (
		<Stack sx={{ p: 2 }}>
			<Stack direction="column" spacing={1}>
				<List component="nav" sx={{ pr: 2 }}>
					<ListSubheader sx={{ mr: -3.75 }} component="div">
						<Link onClick={()=>navigate('/students')}>
							<Typography variant="subtitle1" sx={{ fontWeight: 600, fontVariant: 'small-caps', pb: 1 }}>Students</Typography>
						</Link>
					</ListSubheader>
					{students?.length > 0 && _.sortBy(students, 'name').map((otherStudent, index) => (
						<ListItemButton sx={{ mr: -3.75 }} selected={otherStudent.id == student.id} key={otherStudent.id}>
							<StudentName student={otherStudent} />
						</ListItemButton>
					))}
				</List>
			</Stack>

			<Paper sx={{ p: 2, flexGrow: 1 }}>
				<Grid2 container spacing={4}>
					<Grid2 size={{ xs: 12, md: 6, lg: 4, xl: 3 }}>
						<StudentCard student={student} />
					</Grid2>
					<Grid2 size={6}>

					</Grid2>

					<Grid2 size={{ xs: 12, lg: 8 }}>
						{renderEnrollmentGroup('Active Courses', activeEnrollments)}
						{renderEnrollmentGroup('Upcoming Courses', upcomingEnrollments)}
						{renderEnrollmentGroup('Unplanned Courses', unplannedEnrollments)}
						{renderEnrollmentGroup('Completed Courses', completedEnrollments)}
					</Grid2>

					<Grid2 size={{ xs: 12, lg: 4 }}>
						<Paper sx={{ p: 2 }}>
							<Typography variant="h5" align="center" sx={{ pb: 2 }}>Today</Typography>
							<MonthlyDay date={date} activities={calendar.filteredActivities} showScore={true} showStudent={false} />
						</Paper>
					</Grid2>
				</Grid2>
			</Paper>

			<SpeedDial sx={{ position: 'fixed', bottom: 10, right: (sessionData.drawerOpen ? 350 : 40), alignItems: 'end', '.MuiSpeedDial-actions': { alignItems: 'end', '.MuiFab-circular': { borderRadius: 2, width: 'auto' } } }} color="primary" icon={<SpeedDialIcon />} ariaLabel="">
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>New Student</Typography>} onClick={() => dialogs.open('student', {})} />
			</SpeedDial>
		</Stack>
	);
}